const ctaCon = document.querySelector('.block-cta-standard__container');
if (ctaCon) {
	ctaCon.setAttribute('data-aos', 'fade');
	ctaCon.setAttribute('data-aos-duration', '800');
}
